// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"548":"338f529c","812":"6c414af0"}[chunkId] + ".js";
};